import React, { useContext } from 'react';

import { LayoutContext } from '@/components/Layout';
import { REMOVED_SONG_NAME } from '@/config/constants';
import { useLayout } from '@/providers/LayoutProvider';
import { LimitedTeamSong, useTeamSongs } from '@/providers/TeamSongsProvider';

import { SmallSongCard, SmallSongCardProps } from '../SmallSongCard';

export interface Song {
	name: string;
	artworkUrl?: string | null;
	rotationStatus?: string | null;
}

export type SmallTeamSongCardProps = Omit<
	SmallSongCardProps,
	'song' | 'onClick'
> & {
	teamSongId?: string;
	onClick?: (song: LimitedTeamSong) => void;
	noClick?: boolean;
	skipRemoved?: boolean;
	isModalViewOnly?: boolean;
};

export const SmallTeamSongCard: React.FC<SmallTeamSongCardProps> = ({
	teamSongId,
	onClick,
	noClick,
	skipRemoved,
	isModalViewOnly = false,
	className,
	...smallSongCardProps
}) => {
	const { findTeamSongsById, isLoading } = useTeamSongs();
	const teamSong = findTeamSongsById([teamSongId])[0];
	const { openSong } = useLayout();

	if (!teamSong) {
		return skipRemoved ? null : (
			<SmallSongCard
				song={{
					artist: '-',
					name: REMOVED_SONG_NAME,
				}}
				className={className}
				isLoading={isLoading}
				removed
				{...smallSongCardProps}
			/>
		);
	}

	return (
		<SmallSongCard
			onClick={
				noClick
					? undefined
					: () => {
							openSong({
								teamSongId,
								viewOnly: isModalViewOnly,
							});
							if (onClick) {
								onClick(teamSong);
							}
					  }
			}
			isLoading={isLoading}
			song={teamSong}
			className={className}
			{...smallSongCardProps}
		/>
	);
};
